export default __webpack_public_path__ + "static/media/seg-0-artist.54a80af1.png";